import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";

@Component({
  selector: 'vb-edit-button',
  templateUrl: './edit-button.component.html',
  styleUrls: ['./edit-button.component.css']
})
export class EditButtonComponent implements OnInit {

  @Input()
  confirmQuestion: string = "Sind Sie sicher?";

  @Input()
  confirmTitle: string;

  @Input()
  helpText: string = "";

  @Input()
  disabledText: string;

  @Input()
  size: string;

  @Input('buttonClass')
  buttonClass: string = "btn-default";

  @Input()
  disabled: boolean;

  @Input()
  confirm: boolean = false;

  @Output()
  buttonClicked: EventEmitter<any> = new EventEmitter<any>();


  constructor() {
  }

  ngOnInit() {

  }

  onButtonClick(event?) {
    this.buttonClicked.emit();
  }

}



// WEBPACK FOOTER //
// ./src/app/core/visbos-core/ui/buttons/edit-button/edit-button.component.ts